var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkuadLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0802 36.34C47.72 36.34 52.078 32.8024 52.078 27.8292C52.078 23.2148 49.2068 20.9589 44.5412 19.7285L42.1828 19.1132C40.2345 18.6005 40.0294 17.8315 40.0294 17.2675C40.0294 16.2933 41.1574 15.9345 42.1315 15.9345C43.6184 15.9345 45.0027 16.4984 46.1819 17.9853L51.2064 13.8324C49.1556 11.0125 46.1306 9.57693 42.1828 9.57693C36.5943 9.57693 32.4414 12.7044 32.3389 17.4726C32.2363 21.5742 34.7486 24.7017 39.6193 25.8809L41.3112 26.2911C43.9772 26.9576 44.4387 27.419 44.4387 28.2906C44.4387 29.316 43.2595 29.7262 42.0802 29.7262C39.7218 29.7262 37.7223 28.752 36.543 27.0601L31.416 31.7257C33.7745 34.8532 37.6197 36.34 42.0802 36.34Z",
    fill: "#364452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8884 35.7761H61.6303V24.2915L71.1665 35.7761H80.549L68.8594 21.728L78.2931 10.1409H69.1157L61.6303 19.3183V10.2991H53.8884V35.7761Z",
    fill: "#364452"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1001 35.7761C93.4327 35.7761 91.3427 35.7761 94.3726 35.7761C97.4026 35.7761 103.515 31.3453 103.515 24.7529V10.1409H95.7735V22.5996C95.7735 27.3165 93.8765 29.316 90.9541 29.316C88.0829 29.316 87.0063 27.1627 87.0063 23.4199V10.1409H79.2644V24.7529C79.2644 31.7257 83.7426 35.7761 90.1001 35.7761Z",
    fill: "#364452"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.849 36.34C120.284 36.34 122.797 34.5969 123.822 33.2126V35.7761H131.564V10.1409H123.822V12.7044C122.797 11.3201 120.284 9.57693 116.849 9.57693C110.133 9.57693 104.954 15.6781 104.954 22.9585C104.954 30.2389 110.133 36.34 116.849 36.34ZM118.592 29.316C115.106 29.316 112.748 26.65 112.748 22.9585C112.748 19.267 115.106 16.601 118.592 16.601C122.079 16.601 124.437 19.267 124.437 22.9585C124.437 26.65 122.079 29.316 118.592 29.316Z",
    fill: "#364452"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.287 36.34C148.722 36.34 151.234 34.5969 152.259 33.2126V35.7761H160.001V0H152.259V12.7044C151.234 11.3201 148.722 9.57693 145.287 9.57693C138.57 9.57693 133.392 15.6781 133.392 22.9585C133.392 30.2389 138.57 36.34 145.287 36.34ZM147.03 29.316C143.543 29.316 141.185 26.65 141.185 22.9585C141.185 19.267 143.543 16.601 147.03 16.601C150.516 16.601 152.875 19.267 152.875 22.9585C152.875 26.65 150.516 29.316 147.03 29.316Z",
    fill: "#364452"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39203 18.8472C6.24659 16.9927 9.25341 16.9927 11.108 18.8472L15.4992 23.2384L11.108 27.6296C9.25341 29.4842 6.24659 29.4842 4.39203 27.6296L3.35881 26.5964C1.50426 24.7418 1.50426 21.735 3.35881 19.8804L4.39203 18.8472Z",
    fill: "#1CBBFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2641 17.7069C30.9746 20.4174 30.9746 24.812 28.2641 27.5225L25.4227 30.3639L17.6736 22.6147L25.4227 14.8656L28.2641 17.7069Z",
    fill: "#FE7360"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.2754,
    y: 6.75146,
    width: 10.959,
    height: 10.959,
    rx: 4.38358,
    transform: "rotate(45 16.2754 6.75146)",
    fill: "#A158FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3995 34.9688C10.4023 32.9716 10.4023 29.7335 12.3995 27.7363L16.5324 23.6034L24.2815 31.3525L20.1486 35.4854C18.1514 37.4826 14.9133 37.4826 12.9161 35.4854L12.3995 34.9688Z",
    fill: "#0BCD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuadLogoLarge);
export default __webpack_public_path__ + "static/media/skuadLogoLarge.b2c1d14580a8fa55388e1fd55a6d596f.svg";
export { ForwardRef as ReactComponent };